export class Document{
  key: string;
  value: string;
}